import cn from "classnames";

import styles from "./TooltipDesktop.module.scss";
import { Tooltip } from "common/UIKit/Tooltip";
import { useAuth } from "hooks/useAuth";
import { therapistName } from "common/utils";
import { ReactComponent as InfoCircle } from "assets/images/icons/info-circle-fill.svg";

export const TooltipDesktop = () => {
  const { user } = useAuth();
  const displayName = therapistName({
    ...user?.user,
  });

  return (
    <Tooltip trigger={<InfoCircle />}>
      <div className={styles.tooltipContent}>
        <h1>About status</h1>
        <div className={styles.tooltipColumn}>
          <div className={cn(styles.circle, styles.green)} />
          <h3>Available</h3>
          <p>
            Your TheraPass profile will show you as available and you will
            receive text messages in real time.
          </p>
        </div>
        <div className={styles.tooltipColumn}>
          <div className={cn(styles.circle, styles.yellow)} />
          <h3>Wait</h3>
          <p>
            Your TheraPass profile will show you as engaged/busy but able to
            receive text messages in real time. Anyone sending you a text
            message will receive an auto-generated text message reply “
            {displayName} is currently engaged but is receiving your message in
            real time and will respond to you at their earliest convenience.”
          </p>
        </div>
        <div className={styles.tooltipColumn}>
          <div className={cn(styles.circle, styles.red)} />
          <h3>Offline</h3>
          <p>
            Your TheraPass profile will show you as unavailable to receive text
            messages in real time and the user will be redirected to an email
            form to send you an email message.
          </p>
        </div>
      </div>
    </Tooltip>
  );
};
